export default {
  "content": "<path d=\"M12.207 5.207l-5.793 5.792H20v2H6.414l5.793 5.793-1.414 1.414-7.5-7.5a1 1 0 010-1.413l7.5-7.5 1.414 1.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};